import { useAppContext } from '@/components/utilities/AppContext';

// Fallback labels used when glossary-settings single-type is empty, missing, or
// the fetched locale has only a subset of fields filled in. Keys match the
// GraphQL query in strapi-graphql-glossary-settings-query.js.
const DEFAULT_LABELS = {
  cs: {
    rootLabel: 'Slovník pojmů',
    breadcrumbAriaLabel: 'Drobečková navigace',
    heroEyebrow: 'Slovník pojmů',
    tocTitle: 'Obsah stránky',
    relatedTermsTitle: 'Příbuzné pojmy',
    furtherReadingTitle: 'Další zdroje',
    searchPlaceholder: 'Hledat pojem…',
    searchAriaLabel: 'Hledat pojem',
    filterLabel: 'Filtr:',
    allLabel: 'Vše',
    resultsSingular: 'pojem',
    resultsFew: 'pojmy',
    resultsMany: 'pojmů',
    emptyTitle: 'Žádný pojem nenalezen',
    emptyDescription: 'Zkuste jiný výraz nebo zrušte filtr.',
    termCardReadLabel: 'Přečíst',
    calloutTipLabel: 'Tip:',
    calloutInfoLabel: 'Info:',
    calloutWarningLabel: 'Pozor:',
    calloutSuccessLabel: 'Dobrá zpráva:'
  },
  pl: {
    rootLabel: 'Słownik pojęć',
    breadcrumbAriaLabel: 'Nawigacja okruszkowa',
    heroEyebrow: 'Słownik pojęć',
    tocTitle: 'Spis treści',
    relatedTermsTitle: 'Powiązane pojęcia',
    furtherReadingTitle: 'Dodatkowe materiały',
    searchPlaceholder: 'Szukaj pojęcia…',
    searchAriaLabel: 'Szukaj pojęcia',
    filterLabel: 'Filtr:',
    allLabel: 'Wszystko',
    resultsSingular: 'pojęcie',
    resultsFew: 'pojęcia',
    resultsMany: 'pojęć',
    emptyTitle: 'Nie znaleziono pojęcia',
    emptyDescription: 'Spróbuj innego wyrażenia lub wyczyść filtr.',
    termCardReadLabel: 'Czytaj',
    calloutTipLabel: 'Wskazówka:',
    calloutInfoLabel: 'Info:',
    calloutWarningLabel: 'Uwaga:',
    calloutSuccessLabel: 'Dobra wiadomość:'
  }
};

const mergeLabels = (settings, locale) => {
  const base = locale !== 'pl' ? DEFAULT_LABELS.cs : DEFAULT_LABELS.pl;
  if (!settings) return base;
  const merged = { ...base };
  for (const key of Object.keys(base)) {
    const value = settings[key];
    if (typeof value === 'string' && value.trim() !== '') {
      merged[key] = value;
    }
  }
  return merged;
};

export const useGlossaryLabels = () => {
  const { glossarySettings, locale } = useAppContext();
  return mergeLabels(glossarySettings, locale);
};

export const getGlossaryLabels = (settings, locale) => mergeLabels(settings, locale);
